<template>
  <div class="pdf-selector-wrapper">
    <div class="pdf-dropdown" @click="pdfs.length ? toggleDropdown() : null" :class="{'disabled-dropdown' : !pdfs.length}">
      <span v-if="pdfs.length">{{ $t('my_events.select_pdf') }}</span>
      <span v-if="!pdfs.length">{{ $t('my_events.no_pdf') }}</span>
    </div>
    <div class="pdf-option-group-wrapper">
      <div class="row pdf-option-group" v-for="pdf in pdfs">
        <div class="col-xs-8">
          <span class="option__title">
              <a :href="pdf.download" target="_blank" v-text="pdf.name"></a>
          </span>
        </div>
        <div class="col pdf-download-wrapper">
          <a 
            :href="pdf.download" 
            :disabled="!pdfs.length" 
            class="btn is-blue is-small" 
            title="Download">
            <i class="fa fa-download" aria-hidden="true"></i>
          </a>
        </div>
        <div class="col pdf-delete-wrapper">
          <a :href="pdf.delete" class="btn is-red is-small" title="Löschen">
            <i class="fa fa-trash" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {redirect} from '../../utility'
import { loading } from '../../core/page-loader'

export default {
    name: 'PdfSelector',
    props: {
        pdfs: {
            type: Array,
            default: function() {
                return []
            }
        },
        foreignId: {
          type: String,
          required: true
        },
        foreignType: {
          type: String,
          required: true
        }
    },
    created() {
      this.$event.$on('generate-pdf', (payload) => {
        if(this.foreignId === payload.id && this.foreignType === payload.type) {
          this.generatePdf()
        }
      })
    },
    methods: {
        toggleDropdown() {
            let thiswrapper = $(this.$el)

            $('.pdf-selector-wrapper').not(thiswrapper).removeClass('dropdown-open')
            thiswrapper.toggleClass('dropdown-open')

            $(document).on('click', function (e) {
                if (!$(e.target).is('.pdf-option-group-wrapper, .pdf-option-group-wrapper *, .pdf-dropdown, .pdf-dropdown *') && $('.dropdown-open').length) {
                    $('.dropdown-open').removeClass('dropdown-open')
                }
            })
        },
        generatePdf() {
          let ajax = 'calculation/container/' +  this.foreignId + '/pdf'
          loading(true)

          if(this.foreignType === '\\App\\Calculation') {
            ajax = 'calculation/'+this.foreignId+'/pdf/generateAndDownload'
          }

          axios.get(ajax).then((response) => {
            this.$event.$emit('pdf-created')
            redirect(response.data['pdf-download-link'])
            loading(false)
          })
        }
    }
}
</script>
